import { Component, OnInit } from '@angular/core';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { MyPromise } from '../../../interceptors/myPromise.service';
// const Feed = require('rss-to-json');

@Component({
  selector: 'ngx-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss'],
})
export class NoticesComponent implements OnInit {
  notices = [];
  url = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@taylorotwell';
  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  async ngOnInit() {
    await this.loadNotices();
  }

  async loadNotices() {
    const [err, result] = await this.myPromise.to(this.http.get(this.url));
    if (err) console.error(err);
    return;
    // @ts-ignore
    // this.notices = result.items;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
